(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["hero-slideshow"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hero-slideshow')) {
    class HeroSlideshow extends HTMLElement {
      connectedCallback() {
        this.mq = window.matchMedia('(max-width: 749px)');
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.ready = false;
        this.viewport = this.querySelector('.hero-slideshow__viewport');
        this.track = this.querySelector('.hero-slideshow__track');
        this.slides = Array.from(this.track.querySelectorAll(':scope > .hero-slide'));
        this.control = this.querySelector('.hero-slideshow__control');
        this.dotsWrap = this.querySelector('.hero-slideshow__dots');
        this.autoplay = this.dataset.autoplay === 'true';
        this.interval = parseInt(this.dataset.interval, 10) || 5000;
        this.index = 0;
        this.hovering = false;
        this.focused = false;
        this.editing = false;

        const count = this.slides.length;
        this.classList.toggle('is-single', count <= 1);

        // Slide semantics
        this.slides.forEach((slide, i) => {
          slide.setAttribute('role', 'group');
          slide.setAttribute('aria-roledescription', 'slide');
          slide.setAttribute('aria-label', i + 1 + ' / ' + count);

          slide.querySelectorAll('video[data-src]').forEach((video) => {
            video.addEventListener('loadedmetadata', () => {
              if (video.videoWidth && video.videoHeight) {
                video.style.aspectRatio = video.videoWidth + ' / ' + video.videoHeight;
              }
            });
          });
        });

        // Dots
        this.dots = [];
        if (this.dotsWrap && count > 1) {
          this.dotsWrap.innerHTML = '';
          this.slides.forEach((_, i) => {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'hero-slideshow__dot';
            dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
            dot.addEventListener('click', () => this.goTo(i));
            this.dotsWrap.appendChild(dot);
            this.dots.push(dot);
          });
        }

        // Arrows
        const prev = this.querySelector('.hero-slideshow__arrow--prev');
        const next = this.querySelector('.hero-slideshow__arrow--next');
        if (prev) prev.addEventListener('click', () => this.goTo(this.index - 1, true, -1));
        if (next) next.addEventListener('click', () => this.goTo(this.index + 1, true, 1));

        // Swipe
        this.viewport.addEventListener(
          'touchstart',
          (e) => {
            this.touchX = e.touches[0].clientX;
            this.touchY = e.touches[0].clientY;
          },
          { passive: true }
        );
        this.viewport.addEventListener(
          'touchend',
          (e) => {
            if (this.touchX == null || count <= 1) return;
            const dx = e.changedTouches[0].clientX - this.touchX;
            const dy = e.changedTouches[0].clientY - this.touchY;
            this.touchX = null;
            if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
              const dir = dx < 0 ? 1 : -1;
              this.goTo(this.index + dir, true, dir);
            }
          },
          { passive: true }
        );

        // Hold autoplay while the visitor interacts
        this.addEventListener('mouseenter', () => {
          this.hovering = true;
          this.restartTimer();
        });
        this.addEventListener('mouseleave', () => {
          this.hovering = false;
          this.restartTimer();
        });
        this.addEventListener('focusin', () => {
          this.focused = true;
          this.restartTimer();
        });
        this.addEventListener('focusout', (e) => {
          if (this.contains(e.relatedTarget)) return;
          this.focused = false;
          this.restartTimer();
        });

        // Pause / play: stops videos and rotation
        if (this.control) {
          const hasVideo = !!this.querySelector('video[data-src]');
          if (!hasVideo && !(this.autoplay && count > 1)) {
            this.control.hidden = true;
          }
          this.control.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            const wasPaused = this.dataset.paused === 'true';
            this.dataset.paused = String(!wasPaused);
            this.sync();
            this.restartTimer();
            this.control.setAttribute('aria-label', wasPaused ? 'Pause slideshow' : 'Play slideshow');
            this.control.setAttribute('aria-pressed', String(!wasPaused));
          });
        }

        // Height follows the active slide in "fit to media" mode
        this.onResize = () => this.updateHeight();
        if ('ResizeObserver' in window) {
          this.ro = new ResizeObserver(this.onResize);
          this.slides.forEach((slide) => this.ro.observe(slide));
        } else {
          window.addEventListener('resize', this.onResize);
        }

        this.onMq = () => {
          this.sync();
          this.updateHeight();
        };
        this.mq.addEventListener('change', this.onMq);

        // Theme editor: jump to the selected slide and hold it
        this.onBlockSelect = (e) => {
          const slide = e.target.closest && e.target.closest('.hero-slide');
          const i = this.slides.indexOf(slide);
          if (i === -1) return;
          this.editing = true;
          this.goTo(i, false);
        };
        this.onBlockDeselect = () => {
          this.editing = false;
          this.restartTimer();
        };
        this.addEventListener('shopify:block:select', this.onBlockSelect);
        this.addEventListener('shopify:block:deselect', this.onBlockDeselect);

        this.goTo(0, false);
        this.ready = true;
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        if (this.ro) this.ro.disconnect();
        else if (this.onResize) window.removeEventListener('resize', this.onResize);
        if (this.mq && this.onMq) this.mq.removeEventListener('change', this.onMq);
      }

      // dir: 1 = new slide enters from the right, -1 = from the left.
      // If omitted, direction follows the slide order (used by dots).
      goTo(i, animate = true, dir) {
        const count = this.slides.length;
        if (!count) return;
        const from = this.index;
        const to = ((i % count) + count) % count;
        if (dir === undefined) dir = to >= from ? 1 : -1;

        const slide = animate && this.ready && to !== from && !this.reduceMotion.matches;
        const transition = 'transform 0.6s ease';
        this.index = to;

        this.classList.toggle('is-instant', !animate);

        this.slides.forEach((el, idx) => {
          if (idx === to) {
            if (slide) {
              // Park the incoming slide off-screen on the entry side, then slide it in
              el.style.transition = 'none';
              el.style.transform = 'translateX(' + dir * 100 + '%)';
              el.offsetWidth; // force reflow so the start position applies
              el.style.transition = transition;
            } else {
              el.style.transition = 'none';
            }
            el.style.transform = 'translateX(0)';
            el.style.zIndex = '1';
          } else if (idx === from && slide) {
            // Outgoing slide leaves on the opposite side
            el.style.transition = transition;
            el.style.transform = 'translateX(' + -dir * 100 + '%)';
            el.style.zIndex = '0';
          } else {
            el.style.transition = 'none';
            el.style.transform = 'translateX(100%)';
            el.style.zIndex = '0';
          }

          const active = idx === to;
          el.classList.toggle('is-active', active);
          el.inert = !active;
        });
        this.dots.forEach((dot, idx) => {
          dot.setAttribute('aria-current', idx === this.index ? 'true' : 'false');
        });

        this.sync();
        this.updateHeight();
        this.restartTimer();

        if (!animate) {
          requestAnimationFrame(() => {
            requestAnimationFrame(() => this.classList.remove('is-instant'));
          });
        }
      }

      // Load media for the active + next slide, play only the active slide's visible video
      sync() {
        const count = this.slides.length;
        const next = (this.index + 1) % count;
        const paused = this.dataset.paused === 'true';

        this.slides.forEach((slide, i) => {
          const active = i === this.index;
          const preload = active || i === next;

          if (preload) {
            slide.querySelectorAll('img[loading="lazy"]').forEach((img) => {
              img.loading = 'eager';
            });
          }

          slide.querySelectorAll('video[data-src]').forEach((video) => {
            const device = video.dataset.device;
            const visible = device === 'both' || (device === 'mobile') === this.mq.matches;

            if (visible && preload && !video.getAttribute('src')) {
              video.preload = active ? 'auto' : 'metadata';
              video.src = video.dataset.src;
            }

            if (visible && active && !paused) {
              video.play().catch(() => {});
            } else {
              video.pause();
            }
          });
        });
      }

      updateHeight() {
        if (this.classList.contains('hero-slideshow--fixed')) {
          this.viewport.style.height = '';
          return;
        }
        const slide = this.slides[this.index];
        if (slide) this.viewport.style.height = slide.offsetHeight + 'px';
      }

      restartTimer() {
        clearTimeout(this.timer);
        if (
          !this.autoplay ||
          this.slides.length <= 1 ||
          this.dataset.paused === 'true' ||
          this.hovering ||
          this.focused ||
          this.editing
        ) {
          return;
        }
        this.timer = setTimeout(() => this.goTo(this.index + 1, true, 1), this.interval);
      }
    }

    customElements.define('hero-slideshow', HeroSlideshow);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["hero-video-v2"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hero-video-v2')) {
    class HeroVideoV2 extends HTMLElement {
      connectedCallback() {
        this.mq = window.matchMedia('(max-width: 749px)');
        this.videos = Array.from(this.querySelectorAll('video[data-src]'));

        this.videos.forEach((video) => {
          video.addEventListener('loadedmetadata', () => {
            if (video.videoWidth && video.videoHeight) {
              video.style.aspectRatio = video.videoWidth + ' / ' + video.videoHeight;
            }
          });
        });

        this.sync = () => {
          this.videos.forEach((video) => {
            const device = video.dataset.device;
            const visible = device === 'both' || (device === 'mobile') === this.mq.matches;
            if (visible) {
              if (!video.getAttribute('src')) video.src = video.dataset.src;
              if (this.dataset.paused === 'true') {
                video.pause();
              } else {
                video.play().catch(() => {});
              }
            } else {
              video.pause();
            }
          });
        };

        this.mq.addEventListener('change', this.sync);
        this.sync();

        const button = this.querySelector('.hero-video-v2__control');
        if (!button) return;

        button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          const wasPaused = this.dataset.paused === 'true';
          this.dataset.paused = String(!wasPaused);
          this.sync();
          button.setAttribute('aria-label', wasPaused ? 'Pause video' : 'Play video');
          button.setAttribute('aria-pressed', String(!wasPaused));
        });
      }

      disconnectedCallback() {
        if (this.mq && this.sync) this.mq.removeEventListener('change', this.sync);
      }
    }

    customElements.define('hero-video-v2', HeroVideoV2);
  }
  } catch(e) { console.error(e); }
})();

})();
